import { render, staticRenderFns } from "./voucherDetail.vue?vue&type=template&id=0fac974c"
import script from "./voucherDetail.vue?vue&type=script&lang=js"
export * from "./voucherDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports